import React from "react";
import { Link } from 'react-router-dom';
// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const ProductsForYouSm = () => {
    // const settings = {
    //     dots: false,
    //     infinite: false,
    //     speed: 500,
    //     slidesToShow: 4, // Número de elementos visibles por slide
    //     slidesToScroll: 2,
    //     responsive: [
    //         {
    //             breakpoint: 1024,
    //             settings: {
    //                 slidesToShow: 2,
    //                 slidesToScroll: 1,
    //                 infinite: false,
    //                 dots: false,
    //             },
    //         },
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 slidesToShow: 2.5,
    //                 slidesToScroll: 2.5,
    //                 initialSlide: 2.5,
    //             },
    //         },
    //         {
    //             breakpoint: 393,txt-semibold font-family-montserrat font18
    //             settings: {
    //                 slidesToShow: 2,
    //                 slidesToScroll: 2,
    //                 initialSlide: 2,
    //             },
    //         },
    //     ],
    // };

    // const products = [
    //     {
    //         id: 1,
    //         imgUrl: "/img_publics/para-estudiar-desktop.png",
    //     },
    //     {
    //         id: 2,
    //         imgUrl: "/img_publics/para-trabajar-desktop.png",
    //     },
    //     {
    //         id: 3,
    //         imgUrl: "/img_publics/accesorios-desktop.png",
    //     },
    //     {
    //         id: 4,
    //         imgUrl: "/img_publics/para-jugar-desktop.png",
    //     },
    //     {
    //         id: 5,
    //         imgUrl: "/img_publics/comunidad-gamer-desktop.png",
    //     },
    // ];

    // const firstTwoProducts = products.slice(0, 2);
    // const remainingProducts = products.slice(2);

    return (
        <div className="pd-for-you font-family-montserrat">
            <div className="txt-center padding-categories-titles">
                <div className="txt-semibold font-family-montserrat font18 txt-title-product-fy">
                    Los productos ideales para ti
                </div>
            </div>

            <div className="container-100">
                <div className="gap-1em flex-container container-100 container-box-foryou box-foryou1">
                    <div className='box-foryou position-relative '>
                        <Link to='' className="container-100">
                            <h3 className='position-absolute txt-foryou txt-center font800
                          color-blanco'>
                                PARA ESTUDIAR
                            </h3>
                            <img
                                src="http://172.233.171.185:9001/api/v1/buckets/web/objects/download?preview=true&prefix=imagen-estudiarsm.png&version_id=null"
                                alt="imagen estudiar"
                                className="img-responsive mgb177 br9 pointer"
                            />
                        </Link>
                    </div>
                    <div className='box-foryou position-relative '>
                        <Link to='' className="container-100">
                            <h3 className='position-absolute txt-foryou txt-center font800
                          color-blanco'>
                                PARA TRABAJAR
                            </h3>
                            <img
                                src="http://172.233.171.185:9001/api/v1/buckets/web/objects/download?preview=true&prefix=imagen-trabajarsm.png&version_id=null"
                                alt="imagen trabajar"
                                className="img-responsive mgb177 br9 pointer"
                            />
                        </Link>
                    </div>
                </div>
                <div className="container-100 container-box-foryou box-foryou2">

                    <div className='box-foryou position-relative'>
                        <Link>
                            <h3 className='position-absolute txt-foryou container-100 txt-center font800
                          color-blanco'>
                                ACCESORIOS
                            </h3>
                            <img
                                src="http://172.233.171.185:9001/api/v1/buckets/web/objects/download?preview=true&prefix=imagen-accesorio.png&version_id=null"
                                alt="imagen accesorios"
                                className="img-responsive mgb177 br9 pointer"
                            />
                        </Link>
                    </div>
                    <div className='box-foryou position-relative'>
                        <Link>
                            <h3 className='position-absolute txt-foryou container-100 txt-center font800
                          color-blanco'>
                                PARA JUGAR
                            </h3>
                            <img
                                src="http://172.233.171.185:9001/api/v1/buckets/web/objects/download?preview=true&prefix=imagen-jugar.png&version_id=null"
                                alt="imagen para jugar"
                                className="img-responsive mgb177 br9 pointer"
                            />
                        </Link>
                    </div>
                    <div className='box-foryou position-relative'>
                        <Link>
                            <h3 className='position-absolute txt-foryou container-100 txt-center font800
                          color-blanco'>
                                COMUNIDAD GAMER
                            </h3>
                            <img
                                src="http://172.233.171.185:9001/api/v1/buckets/web/objects/download?preview=true&prefix=comunidad-gamersm.png&version_id=null"
                                alt="imagen comunidad gamer"
                                className="img-responsive mgb177 br9 pointer"
                            />
                        </Link>
                    </div>

                </div>
            </div>


            {/* <div className="container-foryou-sm">
                <div className="flex-container-wrap-sm">
                    {firstTwoProducts.map((c) => (
                        <div key={c.id}>
                            <img
                                src={c.imgUrl}
                                alt={`Producto ${c.id}`}
                                className="img-responsive mgb177 br9 pointer"
                            />
                        </div>
                    ))}
                </div>

                <div className="flex-container-wrap-sm">
                    {remainingProducts.map((c) => (
                        <div key={c.id}>
                            <img
                                src={c.imgUrl}
                                alt={`Producto ${c.id}`}
                                className="img-responsive mgb177 br9 pointer"
                            />
                        </div>
                    ))}
                </div>
            </div> */}
        </div>
    );
};